module.exports = __webpack_public_path__ + "k.no1.e77eead5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/k.no1.jpg
// module id = oQLP
// module chunks = 0